import React from 'react';
import PropTypes from 'prop-types';
import keys from "lodash/keys";
import pickBy from "lodash/pickBy";
import groupBy from "lodash/groupBy";
import isEmpty from 'lodash/isEmpty';
import Cookie from 'react-cookie';
import { Profile } from 'api/api-profile';
import { Spinner } from '../decorators/spinner';
import { FormattedMessage } from 'react-intl';
import BootstrapModal from '../search-module/components/bootstrap-modal';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';

export class LocaleSelectorModal extends React.Component {
    constructor(props) {
        super(props);
        const envLocaleMap = SharedIntlProviderHOC.getEnvLocaleData();
        this.state = {
            initialLocaleData: props.currentLocaleData,
            selectedLocaleData: props.currentLocaleData,
            localeData:  props.activeLocales || envLocaleMap,
            profileUpdateHasError: false,
            profileUpdateLoading: false
        };
        this.onLocaleChanged = this.onLocaleChanged.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.selectLocale = this.selectLocale.bind(this);
    }

    onLocaleChanged () {
        const currentLocale = Cookie.load('preferred_locale') || Cookie.load('initial_locale');
        const accessToken = PSSessions.Cookies('PSAccess');
        const ssoID = PSSessions.Cookies('PSUser');
        if (currentLocale != this.state.selectedLocaleData.locale) { //locale changed
            this.setState({
                profileUpdateHasError: false,
                profileUpdateLoading: true
            })
            analyticsIntegrations.trackEvent("locale updated", {
                changed_from: this.state.initialLocaleData.locale,
                changed_to: this.state.selectedLocaleData.locale,
                ui_element: this.props.triggerSource,
                ssoid: ssoID
            });
            if (!accessToken) {//user not logged in, just change the cookie
                Cookie.save('preferred_locale', this.state.selectedLocaleData.locale, {
                    path: '/',
                    expires: new Date((Date.now()) + (60 * 60 * 6 * 1000)),
                    domain: window.location.host,
                    secure: -1 !== window.location.protocol.indexOf('s'),
                });
                window.location.reload()
            }
            else { //user logged in, proceed to updating profile and cookie
                const profileBody = {
                    preferred_locale: this.state.selectedLocaleData.locale
                };
                Profile.update('me', accessToken, profileBody, (response) => {
                    if (!response.error) {
                        Cookie.save('preferred_locale', this.state.selectedLocaleData.locale, {
                            path: '/',
                            expires: new Date((Date.now()) + (60 * 60 * 6 * 1000)),
                            domain: window.location.host,
                            secure: -1 !== window.location.protocol.indexOf('s'),
                        });
                        window.location.reload();
                    } else {
                        this.setState({
                            selectedLocaleData: this.state.initialLocaleData, //reset to original locale since update didn't go through
                            profileUpdateHasError: true,
                            profileUpdateLoading: false
                        })
                    }
                });
            }

        }
    }

    isSelected (localeData) {
        return this.state.selectedLocaleData.locale == localeData.locale ? 'text-white btn-primary border-0' : 'border-gray-400 bg-hover-gray-100';
    }

    selectLocale (localeData) {
        if (this.state.selectedLocaleData != localeData) {
            this.setState({
                selectedLocaleData: localeData
            }, this.onLocaleChanged)
        }
    }

    render() {
        const { showModal, onModalClose } = this.props;
        const { profileUpdateLoading, profileUpdateHasError, localeData } = this.state;
        const locales = keys(pickBy(localeData, localeData => localeData.language && localeData.country)); //we only want the locales with langauage and country. This will exclude the fallback locales in the data
        const envLocaleArray = locales.map(locale => {
            return { ...localeData[locale], locale: locale }; //[{"locale":"en","translations": "en-GB","url_prefix": "uk","region": "Europe","language": "English","country": "United Kingdom"}]
        })
        const envLocaleDataByRegion = groupBy(envLocaleArray, 'region');

        return (
            <BootstrapModal
                showModal={showModal}
                modalSize="md-size"
                modalClass="padding-lg w-100"
                onClose={onModalClose}
                header={!profileUpdateLoading && <div className="text-left" style={{ marginTop: '-32px', marginBottom: '-16px' }}>
                    <h5 className="no-margin"><FormattedMessage id="shared_component.language_country_selector.header" defaultMessage="Customize your experience" /></h5>
                    <div className='text-gray-600 margin-md-top'><FormattedMessage id="shared_component.language_country_selector.subheader" defaultMessage="Set your preferred language and region" /></div>
                </div>}
                bodyClass="padding-lg"
                body={
                    profileUpdateLoading ?
                        <div style={{ height: 400 }} className='flex column center middle'>
                            <Spinner additionalStyle="gray" />
                        </div>
                        :
                        <div>
                            {profileUpdateHasError && <div className="text-red bg-gray-100 border-radius-sm padding-md-top padding-md-bottom padding-lg-left padding-lg-right border-radius-sm"><FormattedMessage id="shared_component.language_country_selector.error_msg" defaultMessage="Unknown error occured. Please try again." /></div>}
                            <div className="flex column margin-lg-top">
                                {
                                    keys(envLocaleDataByRegion).map(region => {
                                        return (<div className="margin-lg-bottom" key={`${region}`}>
                                            <div className="heavy margin-md-bottom">{region}</div>
                                            <div className="flex flex-wrap no-margin">
                                                {
                                                    envLocaleDataByRegion[region].map((localeData, index) => {
                                                        return (
                                                            <div className="col-xs-12 col-sm-12 col-md-4 no-gutter-left margin-lg-bottom" key={localeData.country}>
                                                                <button onClick={() => { this.selectLocale(localeData) }} className={`btn-block btn text-xs-left ${this.isSelected(localeData)}`} key={`${region}-lang-country-${index}`}>
                                                                    <div className="heavy">{localeData.language}</div>
                                                                    <div className="normal">{localeData.country}</div>
                                                                </button>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>);
                                    })
                                }
                            </div>
                        </div>
                }
            />
        );
    }
}

LocaleSelectorModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    currentLocaleData: PropTypes.object.isRequired,
    triggerSource: PropTypes.string.isRequired
};